import Axios from 'axios'
// 第三方登录及授权接口  同一个接口 只是传参不一样
export function thirdPartyLoginAuth(data) {
    return Axios.post(`${window.Glod['ccex-apitsf']}/services/oauth2/authorize`,data )
}
